import CreateAutoProjectButtonsView from './View/CreateAutoProjectButtons.view';

export default CreateAutoProjectButtonsView;
